import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">

      <div className="max-w-7xl mx-auto px-6 py-16">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">

          {
/* LOGO */}
<div>
  <div className="flex items-center gap-3 mb-6">
    <img
      src="/images/logo-white.svg"
      alt="SafeLine Solutions"
      width={56}
      height={56}
      loading="lazy"
      decoding="async"
      fetchPriority="low"
      className="h-14 w-auto object-contain"
    />
  </div>

  <p className="text-white/80 text-sm leading-relaxed mb-6">
    SafeLine Solutions SPA – Servicios HSE, acreditación y cumplimiento.
  </p>
</div>


          {/* SERVICIOS */}
          <div>

            <h3 className="text-lg font-bold mb-4">
              Servicios
            </h3>

            <ul className="space-y-3">

              <li>
                <Link
                  to="/gestion-documental"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Gestión Documental
                </Link>
              </li>

              <li>
                <Link
                  to="/auditorias"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Auditorías HSE
                </Link>
              </li>

              <li>
                <Link
                  to="/asesoria-terreno"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Asesoría Operacional
                </Link>
              </li>

              <li>
                <Link
                  to="/sistemas-gestion"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Sistemas de Gestión
                </Link>
              </li>

              <li>
                <Link
                  to="/capacitacion"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Capacitación
                </Link>
              </li>

            </ul>

          </div>

          {/* NAVEGACIÓN */}
          <div>

            <h3 className="text-lg font-bold mb-4">
              Navegación
            </h3>

            <ul className="space-y-3">

              <li>
                <Link
                  to="/"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Inicio
                </Link>
              </li>

              <li>
                <Link
                  to="/servicios"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Servicios
                </Link>
              </li>

              <li>
                <Link
                  to="/contacto"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Contacto
                </Link>
              </li>

            </ul>

          </div>

          {/* HSE CON INTELIGENCIA */}
          <div>

            <h3 className="text-lg font-bold mb-4">
              HSE con Inteligencia
            </h3>

            <ul className="space-y-3">

              <li>
                <Link
                  to="/hse-con-inteligencia"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Libro 1 · Patrones y Prevención
                </Link>
              </li>

              <li>
                <Link
                  to="/safeline-ai-hub"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Safeline Ai Hub
                </Link>
              </li>

            </ul>

          </div>

          {/* CONTACTO */}
          <div>

            <h3 className="text-lg font-bold mb-4">
              Contacto
            </h3>

            <ul className="space-y-3">

              <li className="flex items-start gap-2">

                <i className="ri-mail-line text-lg flex-shrink-0 mt-0.5"></i>

                <a
                  href="mailto:operaciones@safelinesolutions.net"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  operaciones@safelinesolutions.net
                </a>

              </li>

              <li className="flex items-start gap-2">

                <i className="ri-global-line text-lg flex-shrink-0 mt-0.5"></i>

                <a
                  href="https://www.safelinesolutions.net"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  www.safelinesolutions.net
                </a>

              </li>

              <li className="flex items-start gap-2">

                <i className="ri-linkedin-box-fill text-lg flex-shrink-0 mt-0.5"></i>

                <a
                  href="https://www.linkedin.com/company/safeline-solutions"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors text-sm rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  linkedin.com/company/safeline-solutions
                </a>

              </li>

            </ul>

          </div>

        </div>

        {/* BOTTOM */}
        <div className="border-t border-white/20 pt-8">

          <div className="flex flex-col md:flex-row justify-between items-center gap-4">

            <p className="text-white/70 text-sm">
              © 2025 SafeLine Solutions SPA. Todos los derechos reservados.
            </p>

          </div>

        </div>

      </div>

    </footer>
  );
}